module.exports = __webpack_public_path__ + "static/media/icon_checkout_order.c03f30f7.svg";